<template>
  <ion-page>
    <ion-header>
      <ion-toolbar lines="none" translucent class="menu-toolbar">
        <ion-buttons slot="end" @click="goPrev()">
          <div class="pl-05">
            <ion-icon :icon="closeOutline" size="large" />
          </div>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="profile" v-if="member">
      <div class="d-flex gap-10 align-items-center pl-20">
        <img :src="get(member, 'isPublic', true) && member.meta && member.meta.showImg !== false && presentation.showLogo && member.meta.imgUrl ? member.meta.imgUrl : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRt9KcSYpVsC4b1o_3v2QgaIyo3NxOk6v9eoQ&usqp=CAU'" class="player-avatar" />
        <ion-label>
          <div class="flex">
            <h2>{{ get(member, 'isPublic', true) && get(member, 'profile') && get(member, 'profile.firstName') && get(member, 'profile.lastName') ? get(member, 'profile.firstName') + ' ' + get(member, 'profile.lastName') : 'Player' }}</h2>
            <ion-card class="card-sspd" v-if="get(member, 'meta.suspend.isSuspended')">
              SSPD
            </ion-card>
          </div>
          <p class="team-name">{{ latestTeamName }}</p>
        </ion-label>
      </div>

      <!-- <ion-grid :scroll-x="true" class="option-row ml-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
        <ion-chip v-for="option in submenu" :key="option" @click="currentOption = option" :class="{
          'mt-20': true,
          chip: true,
          active: option === currentOption,
          selectable: option !== currentOption
        }">
          <ion-label >{{ option }}</ion-label>
        </ion-chip>
      </ion-grid> -->

      <section class="overview-section" v-if="currentOption === 'Overview'">
        <h2 class="c-white pl-20">This Season</h2>
        <div class="overview mt-20">
          <div class="overview-line">
            <div class="overview-box">
              <p class="f-bold c-white"> {{ allTeamMatches }} </p>
              <p class="c-gray">Matches Played</p>
            </div>
            <div class="overview-box">
              <p class="f-bold c-white"> {{ wonThisSeason }} </p>
              <p class="c-gray">Matches Won</p>
            </div>
            <div class="overview-box">
              <p class="f-bold c-white"> {{ lostThisSeason }} </p>
              <p class="c-gray">Matches Lost</p>
            </div>
          </div>
        </div>

        <!-- <div class="recent-match" v-if="latestMatch">
          <h2 class="c-white pl-20">Most Recent Match</h2>
          <match-card :match="latestMatch" :key="latestMatch._id" />
        </div> -->

        <div class="line-up p-10">
          <h2 class="c-white pl-10">Performance By Season</h2>
          <ion-grid :scroll-x="true" class="option-row ml-10 mr-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
            <div class="season-stat-header" :style="styleGridTemplateColumns(`3rem 14rem 3rem`, filteredEvents.length)">
              <span class="season"></span>
              <span class="team"> Team </span>
              <span class="matches-played"> P </span>
              <span class="stat" v-for="stat in filteredEvents" :key="`${stat}`"> {{ abbreviate(stat) }}</span>
            </div>
            <!-- <ion-list lines="none" class="mt-20 performance-by-season"> -->
              <div class="season-stat" :style="styleGridTemplateColumns(`3rem 14rem 3rem`, generateStat(row.matches).length)" v-for="row in statBySeason" :key="row._id">
                <span class="season c-gray"> {{ row.season }} </span>
                <span class="team"> {{ row.team }} </span>
                <span class="matches-played"> {{ row.matches.length }} </span>
                <span class="stat" v-for="stat in generateStat(row.matches)" :key="`${stat}-${row._id}`"> {{ this.getVal(stat, generateStat(row.matches)) }}</span>
              </div>
            <!-- </ion-list> -->
          </ion-grid>
        </div>
      </section>

      <section class="matches mt-10 p-10">
        <h2 class="c-white pl-10">Appearances</h2>
        <div class="d-flex flex-column pl-10">
          <ion-item lines="none" v-if="seasons.length">
            <ion-select v-model="seasonFilter">
              <ion-select-option v-for="season in seasons" :value="season" :key="season">{{ season }}</ion-select-option>
            </ion-select>
          </ion-item>
        </div>
        <div class="d-flex flex-column pl-10">
          <ion-item lines="none" v-if="competitions.length">
            <ion-select v-model="compFilter" placeholder="Filter by Competition">
              <ion-select-option v-for="{ competition } in competitions" :value="competition._id" :key="competition._id">{{ competition.name }}</ion-select-option>
            </ion-select>
          </ion-item>
        </div>

        <ion-grid :scroll-x="true" class="option-row ml-10 mr-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap v-if="currentSeasonMatches && currentSeasonMatches.length">
          <div :style="styleGridTemplateColumns(`3.5rem 7.5rem 3rem`, filteredEvents.length)" :class="{'appearance-stat-header': true }">
            <span class="date c-gray"> Rnd </span>
            <span class="date c-gray"> Vs </span>
            <span class="date c-gray"> Result </span>
            <span class="date c-gray" v-for="stat in filteredEvents" :key="stat"> {{ abbreviate(stat) }}</span>
          </div>
          <div :style="styleGridTemplateColumns(`3rem 7.5rem 3rem`, generateStat([row]).length)" :class="{'appearance-stat': true, 'won': heroWon(row), 'lost': heroLost(row) }" v-for="row in currentSeasonMatches" :key="row._id" @click="expandMatch(row._id)">
              <span class="date c-gray"> {{ row.round.name || row.round.number }} </span>
              <div class="d-flex gap-05">
                <!-- <TeamLogo :small="true" /> -->
                <span class="f-bold"> {{ teams.includes(row.awayTeam.name) ? row.homeTeam.name : row.awayTeam.name }} </span>
              </div>
              <span class="c-gray d-flex"> {{ row.scores.homeTeam }} : {{ row.scores.awayTeam }} </span>
              <div class="d-flex flex-column" v-for="stat in generateStat([row])" :key="`${stat}-${row._id}`">
                <!-- <small class="stat-heading c-white f-bold">
                  {{ stat.eventName }}
                </small> -->
                <span class="stat-value c-white f-bold">
                  {{ this.getVal(stat, generateStat([row])) }}
                </span>
              </div>
          </div>
        </ion-grid>

        <div class="option-row d-flex justify-center mt-20" v-else>
          <p class="c-white">
            No matches availble for this season.
          </p>
        </div>

        <ion-list lines="none" class="mt-20 match-stat-section">

        </ion-list>

        <!-- <div class="competition" v-for="{ _id, name, matches } in groupedByComp" :key="`comp-${_id}`">
          <div v-if="matches.length && name === compFilter">
            <match-card :match="match" v-for="match in matches" :key="match._id" class="mb-1" />
          </div>
        </div> -->
      </section>


    </ion-content>
  </ion-page>
</template>

<script>
import {
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  menuSharp,
  closeOutline
} from "ionicons/icons";
// import { loadingController, menuController } from "@ionic/vue";
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import TeamLogo from '../matches/base/team-logo.vue'

export default {
  components: {
    TeamLogo
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      closeOutline,
      menuSharp
    }
  },
  data() {
    // const { filter } = this.$store.state.matches;
    return {
      member: false,
      teamComps: [],
      key: 1,
      submenu: [
        'Overview',
        'Appearances',
      ],
      openedMatches: [],
      matchType: 'Completed',
      currentOption: 'Overview',
      compFilter: false,
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
      get: _.get,
      scoringEvents: [],
      playerMovements: [],
    };
  },
  async mounted() {
    await this.$store.dispatch('national/setup');
    try {
      const memberId = this.$route.params.id;
      const resMember = await this.$http.get(`/assemble/api/v1/live/members/${+memberId}`);
      if (!resMember.data) {
        this.$router.push('/');
        return;
      }
      this.member = resMember.data.data.member;
      this.teamComps = resMember.data.data.compAndMatches;
      this.seasonFilter = this.seasons[0];
      this.compFilter = this.competitions[0] ? this.competitions[0].competition._id : false;
      this.getEventsByTeamComps();
    } catch (error) {
      console.log(error);
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
  },
  computed: {
    presentation() {
      return this.$store.getters['national/presentation'];
    },
    entity() {
      return this.$store.getters['national/getEntity'];
    },
    // ...mapGetters('national', ['scoringEvents', 'playerMovements']),
    filteredEvents() {
      const events = this.scoringEvents.concat(this.playerMovements).filter(e => e.visibleInLadders || e.visibleInLadders === undefined);
      if([8, 12].includes(this.nationalId)) {
        return this.reOrderEvent(events);
      }
      return events;
    },
    latestTeamName() {
      const { teamComps } = this;
      if (!teamComps || !teamComps.length) return '';
      return teamComps[0].name;
    },
    seasons() {
      const { teamComps } = this;
      return teamComps.map(c => c.competition.season).filter((v, i, a) => a.indexOf(v) === i);
    },
    teams() {
      const { teamComps } = this;
      return teamComps.map(t => t.name).filter((v, i, a) => a.indexOf(v) === i);
    },
    statBySeason() {
      const { teamComps, seasons, teams } = this;
      const statBySeason = seasons.reduce((acc, season) => {
        const byTeam = teams
          .reduce((ac, team) => {
            const matches = teamComps
              .filter(c => c.matches.length && c.competition.season === season && c.name === team)
              .map(c => c.matches)
              .flat();
            return ac.concat({ season, team, matches });
          }, []);
        return acc.concat(byTeam);
      }, []);
      // { season, team }
      return statBySeason;
    },
    currentSeasonMatches() {
      const { teamComps, seasonFilter } = this;
      const tC = teamComps
        .sort((a, b) => {
          if (!a.round || a.round.number || !b.round || !b.round.number) return 0;
          return a.round.number > b.round.number ? 1 : -1;
        })
        .filter(c => c.competition.season === seasonFilter)
        .filter(c => this.compFilter ? c.competition._id === this.compFilter : true)
        .map(c => c.matches)
        .flat();
      const sortedTC = _.sortBy(tC, ['round.number']);
      return sortedTC;
    },
    allTeamMatches() {
      const { teamComps, seasonFilter } = this;
      const tC = teamComps
        .filter(c => c.competition.season === seasonFilter);

      return _.flatten(_.map(tC, t => t.matches)).length;
    },
    wonThisSeason() {
      const { currentSeasonMatches } = this;
      return currentSeasonMatches.filter(m => this.heroWon(m)).length
    },
    lostThisSeason() {
      const { currentSeasonMatches } = this;
      return currentSeasonMatches.filter(m => this.heroLost(m)).length
    },
    competitions() {
      const { teamComps } = this;
      const uniq = teamComps.map(c => c.competition._id).filter((v, i, a) => a.indexOf(v) === i);
      return uniq.map(id => teamComps.find(c => c.competition._id === id));
    }
  },
  methods: {
    async getEventsByTeamComps() {
      const { teamComps } = this;
      const mappedCompIds = _.map(teamComps, 'competition._id');
      const competitionIds = _.filter(mappedCompIds, (c) => c);
      // [POST] assemble/api/v1/live/competitions/events
      const resCompEvents = await this.$http.post('/assemble/api/v1/live/competitions/events', { competitionIds });
      const scoringEvents = _.get(resCompEvents, 'data.data.allEventsCombined.scoringEvents', []);
      const playerMovements = _.get(resCompEvents, 'data.data.allEventsCombined.playerMovements', []);
      this.scoringEvents = scoringEvents;
      this.playerMovements = playerMovements;
    },
    styleGridTemplateColumns(frontColumns, numColumns) {
      const style = {gridTemplateColumns: `${frontColumns} repeat(${numColumns}, 2.5rem)`};
      return style;
    },
    reOrderEvent(events) {
      // G PG YC, 2M, RC and BC
      return [events[0], events[1], events[3], events[5], events[2], events[4]];
    },
    getVal(stat, matches) {
      if ((this.nationalId === 8 || this.nationalId === 12) && stat.eventName === 'Goal') {
        const getPG = matches.find((m) => m.eventName === 'Penalty Goal');

        return stat.total + getPG.total;
      }

      return stat.total;
    },
    expandMatch(matchId) {
      if (this.openedMatches.includes(matchId)) {
        this.openedMatches = this.openedMatches.filter(m => m !== matchId);
      } else {
        this.openedMatches.push(matchId);
      }
    },
    random() {
      return Math.random() > 0.5;
    },
    formatDateTime(timestamp) {
      return moment(timestamp).format('DD/MM/YY');
    },
    goPrev() {
      this.$router.go(-1);
    },
    abbreviate(stat) {
      if (stat.abbreviation) return stat.abbreviation;
      return stat.name.split(' ').map(s => s.charAt(0)).join('');
    },
    heroWon(row) {
      const isHomeTeam = this.teams.find(t => t === row.homeTeam.name);
      if (isHomeTeam) return row.scores.homeTeam > row.scores.awayTeam;
      return row.scores.awayTeam > row.scores.homeTeam;
    },
    heroLost(row) {
      const isHomeTeam = this.teams.find(t => t === row.homeTeam.name);
      if (isHomeTeam) return row.scores.homeTeam < row.scores.awayTeam;
      return row.scores.awayTeam < row.scores.homeTeam;
    },
    generateStat(matches) {
      const { scoringEvents, playerMovements } = this;
      const playerId = +this.$route.params.id;
      const matchesWithPlayer = matches.filter(m => m.scoringEvents.some(e => e.meta && e.meta.player && e.meta.player._id === playerId));
      const matchesWithPlayerMovements = matchesWithPlayer.filter(m => m.playerMovements.some(e => e.meta && e.meta.player && e.meta.player._id === playerId));
      const scorings = scoringEvents
        .filter(e => e.visibleInLadders || e.visibleInLadders === undefined)
        .reduce((acc, event) => {
          const { type, name: eventName } = event;
          const total = matchesWithPlayer.reduce((ac, match) => {
            const { scoringEvents } = match;
            const eventTotal = scoringEvents.filter(e => e.type === type && e.meta && e.meta.player && e.meta.player._id === playerId).length
            return ac + eventTotal;
          }, 0);
          return acc.concat({ type, total, eventName });
        }, [])
      const movements = playerMovements
        .filter(e => e.visibleInLadders || e.visibleInLadders === undefined)
        .reduce((acc, event) => {
          const { type, name: eventName } = event;
          const total = matchesWithPlayerMovements.reduce((ac, match) => {
            const { playerMovements } = match;
            const eventTotal = playerMovements.filter(e => e.type === type && e.meta && e.meta.player && e.meta.player._id === playerId).length
            return ac + eventTotal;
          }, 0);
          return acc.concat({ type, total, eventName });
        }, [])
      const stats = scorings.concat(movements);
      if([8, 12].includes(this.nationalId)) {
        // G PG YC, 2M, RC and BC
        return this.reOrderEvent(stats);
      }
      return stats;
      // return scorings;

    },
  }
};
</script>
<style scoped lang="scss">

ion-title {
  font-family: 'Cairo';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

/* Set the width to the full container and center the content */
ion-select {
  width: 100%;
}

h2 {
  font-family: 'Cairo';
}

.c-gray {
  color: #a9a9a9;
}

.c-white {
  color: #fff !important;
}



.performance-by-season {
  border-radius: 1rem;
}

.match-stat-section {
  border-radius: 24px;
  .my-stat {
    transition: height 0.3s ease-in-out;
    height: 0;
    opacity: 0;
    // background: #1d1f22;
    // background: hsl(216, 6%, 8%);
    gap: 1.5rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
    // flex-wrap: wrap;
    // justify-content: space-between;
    small {
      font-family: 'Cairo';
    }
    &.open {
      padding: 0.5rem 1rem;
      height: auto;
      opacity: 1;
    }
  }
}


.season-stat-header {
  display: grid;
  gap: 0.5rem;
  // grid-template-columns: 3rem 9rem 3rem repeat(auto-fill, 2.5rem);
  // background: #1d1f22;
  // border-radius: 14px;
  padding: 0.5rem 1.5rem;
  margin-bottom: 1.5rem;
  // margin-bottom: 0.5rem;
  color: #a9a9a9;
  font-size: 0.8rem;
  font-weight: bold;
  text-overflow: clip;
}

.season-stat {
  display: grid;
  gap: 0.5rem;
  // grid-template-columns: 3rem 9rem 3rem repeat(auto-fill, 2.5rem);
  background: #1d1f22;
  padding: 1rem 1.5rem;
  // border-radius: 14px;
  // padding: 10px;
  // margin-bottom: 1rem;
  // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  // text-align: center;
  color: #fff;
  // grid-template-columns: ;
  text-overflow: clip;
  white-space: nowrap;

  // grid-auto-flow:column;
  // grid-gap:10px;
  // margin:30px;
  // overflow:auto;
}

.appearance-stat-header {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: 2rem 7.5rem 4rem repeat(auto-fill, 2.5rem);
  // background: #1d1f22;
  // border-radius: 14px;
  padding: 0.5rem 1rem;
  margin: 0 0 1rem 0;
  // margin-bottom: 0.5rem;
  color: #a9a9a9;
  font-size: 0.8rem;
  font-weight: bold;
}

.appearance-stat {
  position: relative;

  &.won::after {
    // green line at start
    clip-path: polygon(0% 0%, 49% 0, 49% 82%, 0 100%, 0% 100%);

    content: '';
    position: absolute;
    top: 0;
    left: 0.25rem;
    width: 0.5rem;
    height: 95%;
    background: #00c853;
    // border-radius: 14px;
    z-index: 10;
  }

  &.lost::after {
    // red line at start
    clip-path: polygon(0% 0%, 49% 0, 49% 82%, 0 100%, 0% 100%);

    content: '';
    position: absolute;
    top: 0;
    left: 0.25rem;
    width: 0.5rem;
    height: 90%;
    background: #ff5252;
    // border-radius: 14px;
    z-index: 10;
  }

  ::after {
    clip-path: polygon(0% 0%, 49% 0, 49% 82%, 0 100%, 0% 100%);

    content: '';
    position: absolute;
    top: 0;
    left: 0.25rem;
    width: 0.5rem;
    height: 90%;
    background: #656866;
    // border-radius: 14px;
    z-index: 10;
  }

  display: grid;
  gap: 0.5rem;
  grid-template-columns: 2rem 7.5rem 4rem repeat(auto-fill, 2.5rem);
  // background: #1d1f22;
  padding: 1rem 1.5rem;
  // border-radius: 14px;
  // padding: 10px;
  // margin-bottom: 1rem;
  // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  // width: 100%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  // text-align: center;
  color: #fff;
  // grid-template-columns: ;
}

.profile {
  .player-avatar {
    width: 6rem;
    height: 6rem;
    border-radius: 200px;
  }

  .team-name {
    color: #a9a9a9;
  }
}

.overview {
  padding: 1rem;
  .overview-line {
    display: flex;
    justify-content: space-between;
    @media screen and (min-width: 768px) {
      justify-content: start;
    }

    gap: 1rem;
    .overview-box {
      border-radius: 12px;
      padding: 1rem 1.5rem;
      background: #1e1f22;
      display: flex;
      flex-direction: column;
      // align-items: center;
      p { margin: 0; }
      .f-bold {
        font-size: 1.5rem;
        font-weight: bold;
      }

      .c-gray {
        font-size: 0.8rem;
      }
    }
  }
}

.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  border-radius: 1rem;
  background: #1e1f22 !important;
}

.chip {
  font-size: 1rem;
  color: #a9a9a9;
  font-family: 'Cairo';
  &.active {
    background: var(--highlight-color);
    ion-label {
      color: #000;
    }
    // color: var(--ion-color-primary);
    font-family: 'Cairo';
  }

  &.selectable {
    cursor: pointer;
    color: #a9a9a9;
    background: #1E1F22;
  }
}

.header-bar {
  padding: 0.5rem;
}

.search-bar {
  color: #fff;
}

.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.team-list {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

ion-label {
  color: white;
  font-family: 'Cairo';
  font-size: 0.8rem;
}


ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}

ion-badge {
  white-space: break-spaces;
}

.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
// .light-text {
//   font-size: 14px;
//   font-weight: 400;
//   text-transform: capitalize;
// }
// .normal-text {
//   font-size: 15px;
//   font-weight: 600;
//   text-transform: capitalize;
// }
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}



.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

ion-content {
  background: $background;
  --background: $background;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
}

ion-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::-webkit-scrollbar {
    width: .15rem;
    background-color: rgba(0,0,0,0.3);
  }
}

ion-content::-webkit-scrollbar-thumb
{
  background-color: #888;
}


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.card-sspd {
  background-color: red;
  color: white;
  font-size: 0.8rem;
  min-width: 3rem;
  min-height: 1.2rem;
  border-radius: 25%/50%;
  margin-top: 3px;
  margin-left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
